import { render, staticRenderFns } from "./LinkBuildingItem.vue?vue&type=template&id=4b6ff3a5&scoped=true"
import script from "./LinkBuildingItem.vue?vue&type=script&lang=js"
export * from "./LinkBuildingItem.vue?vue&type=script&lang=js"
import style0 from "./LinkBuildingItem.vue?vue&type=style&index=0&id=4b6ff3a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6ff3a5",
  null
  
)

export default component.exports